var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4.5,
    r: 2.5,
    fill: "#002A69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1745 14C13.3273 14 14.2943 13.0805 13.9171 12.0368C13.6099 11.1867 13.1042 10.4055 12.4277 9.75736C11.2534 8.63214 9.66072 8 8 8C6.33928 8 4.74657 8.63214 3.57227 9.75736C2.89582 10.4055 2.39012 11.1867 2.08292 12.0368C1.70571 13.0805 2.67273 14 3.82549 14L12.1745 14Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/User_avatar.0fb623ca5b8b3751b32844fc3e2e0623.svg";
export { ForwardRef as ReactComponent };